import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(HttpBackend) // load translations via http (lazy)
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass i18n to react-i18next
    .init({
        fallbackLng: 'en', // default language
        // Languages we ship locale files for. Detected regional variants
        // (en-GB, da-DK, …) resolve to their base language instead of
        // requesting a /locales/<variant>/ folder that 404s.
        supportedLngs: ['en', 'da', 'fi', 'fr', 'no', 'pt-BR', 'pt-PT'],
        debug: true, // disable in production
        interpolation: {
            escapeValue: false, // React already escapes
        },
    });

export default i18n;
